export default __webpack_public_path__ + "static/media/ap-dashboard.b5007316.jpg";